import {useAuth} from "../store/auth-context";
import {Navigate, Outlet} from "react-router-dom";
import {CircularProgress, Box} from "@mui/material";

const ProtectedRoute = (props) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/auth" />;
}

export default ProtectedRoute;